import { useState, useContext } from "react";
import { useNavigate } from 'react-router-dom'
import { AppBar, Box, Grid, LinearProgress, ListItemButton, ListItemIcon, ListItemText, SvgIcon, Typography } from "@mui/material";
import HeaderLogo from "./headerLogo";
import TopNavigation from "./topNavigation";
import MobileContextMenu from "./mobileContextMenu";
import ImpersonationBar from '../impersonationBar';
import { DataContext } from '../../../../contexts/data/dataContext'
import { AuthContext } from '../../../../contexts/auth/authContext'
import { useGetCurrentSession } from '../../../../services/api-query/auth'
import { 
  dashboardIconPath,
  reportsIconPath,
  storeIconPath,
  sunIconPath
} from '../../../common/iconPaths'
import custom from '../../../../styles/mui/szVariables.json'

export default function Header() {
  const pathName = window.location.hash.substring(2) || 'dashboard';
  const auth = useContext(AuthContext)
  const data = useContext(DataContext)
  const [selected, setSelected] = useState(pathName);
  const { currentSession } = useGetCurrentSession()
  const navigate = useNavigate()

  const handleMenuClick = (event: any) => {
    const id = `${event.currentTarget.id}`.replace('Mobile','')
    setSelected(id)
    navigate(`/${id}`)
  }

  const colorSelected = "primary.main";
  const borderBottom = custom.border;
  const selectedBorderBottom = custom.selected;

  let menuItemList = [
    {
        id: 'dashboard',
        name: "Dashboard",
        iconPath: dashboardIconPath,
        action: handleMenuClick
    },
    {
        id: 'performance',
        name: "Performance",
        iconPath: reportsIconPath,
        action: handleMenuClick
    },
    {
      id: 'savings',
      name: "Savings",
      iconPath: sunIconPath,
      action: handleMenuClick
    },
    
  ]
  if(process.env.REACT_APP_STORE_URL && currentSession?.idToken) {
    menuItemList.push({
      id: 'store',
      name: "Store",
      iconPath: storeIconPath,
      action: ()=>{ 
        window.open(`${process.env.REACT_APP_STORE_URL}${currentSession?.idToken}`, "_blank") 
      }
    })
  }

  if(!Array.isArray(data?.savings) || 
      data?.savings.length===0) {
    menuItemList = menuItemList.filter((m:any)=>m.id!=='savings')
  }

  if(data?.customer?.hasUsageData===false) {
    menuItemList = menuItemList.filter((m:any)=>m.id!=='performance')
  }

  const menuItems = (items: any[], bordered = false, drawer?: any ) => (
    <>
      {items.map(item=>(
        <ListItemButton id={item.id} key={item.id} 
          onClick={(event)=>{
            item.action(event)
            if(drawer) drawer(false)
          }} 
          sx={{ marginTop: `${drawer ? '0' : '10px'}`, 
                borderBottom: `${bordered ? borderBottom : 
                                item.id===selected ? selectedBorderBottom: 'none'}`,
                '&:hover': {
                  backgroundColor: 'sz.colors.hover',
                  boxShadow: 'none',                                              
                },
                minWidth: item.id==='store'?'80px':
                          item.id==='savings'?'100px':
                          item.id==='performance'?'150px':
                          item.id==='dashboard'?'120px':0
              }}
          >
          {!drawer?'':
            <ListItemIcon>
                <SvgIcon viewBox="0 0 24 24" 
                        sx={{ 
                            color: `${item.id===selected?colorSelected:
                                    item.id!=='signout'?'inherit':'error.main'}`,
                              pt: "1px" 
                          }}> {item.iconPath} 
                </SvgIcon>
            </ListItemIcon>
          }
          <ListItemText primary={item.name} primaryTypographyProps={{
                textAlign: `${drawer ? "left": "center"}`,
                noWrap: true, 
                color: `${item.id===selected?colorSelected:item.id!=='signout'?
                                    'inherit':'error.main'}` , 
                variant: `${drawer ? 'szHeading.Bold.Small' : 
                                    'szHeading.Regular.xSmall'}`,
                py: '10px',
                pr: `${drawer ? '75px' : 'inherit'}`,
                ml: `${drawer ? '-25px' : 'inherit'}`,
              }} />
        </ListItemButton>
      ))}
    </>
  )

  return (
    <> <ImpersonationBar />
      <AppBar position="fixed" elevation={0}
        sx={{ 
              color: "sz.colors.charcoal", 
              backgroundColor:'sz.colors.background', 
              borderBottom,
              borderTop: auth?.staff?custom.borderRed:0,
              borderLeft: auth?.staff?custom.borderRed:0,
              borderRight: auth?.staff?custom.borderRed:0,
              display:"flex" ,
              flexDirection:"row",
              justifyContent:"center",
            }}>
              <Box display="flex" id="headerContent"
                  boxSizing={'border-box'}
                  flexDirection={"row"}
                  justifyContent={"center"}
                  width="100%" 
                  maxWidth={"1200px"}
                  maxHeight={custom.sizes.hf}
                  >  
                <Grid container direction={"row"} 
                      justifyContent={"center"} 
                      mx={custom.spacing.md}>
                  <Grid item xs={10} sm={11} md={3} lg={4} 
                        justifyContent={"flex-start"} >
                    <HeaderLogo />
                  </Grid>
                  <Grid item xs={2} sm={1} md lg //={2} sm={1} md={9} lg={8} 
                      justifyContent={"flex-center"}
                      alignItems={"flex-start"} maxHeight={custom.sizes.hf}>
                    <TopNavigation 
                      selected={selected}
                      menuItems={menuItems} 
                      itemList={menuItemList}
                    />
                    <MobileContextMenu 
                      selected={selected} 
                      itemList={menuItemList}
                      handleClick={handleMenuClick}
                    />
                  </Grid>               
                </Grid>              
              </Box>             
            <Box display={data?.rightPanel?'block':'none'} 
              width={{ 
                  xs: 0, 
                  sm: 0, 
                  md: 0, 
                  lg: '400px', 
                  xl: '400px' }}
              />
      </AppBar>
      {!data?.dashboard?.cards &&
          <Box width="100vw" zIndex={999}
            top={73} height="5px" 
            position={"fixed"}>
            <LinearProgress />
          </Box>
        }
    </>
  );
}